<script>
  /**@type {boolean}*/
 export let isOpen = false;
</script>

<a href="/" aria-labelledby="logo" on:click={()=> isOpen = false}>
  <img
    src="/images/global/GelishMorganTaylorLogo.svg"
    alt="The home of Gelish and Morgan Taylor"
    width="99px"
    height="27px"
    loading="eager"
  />
</a>

<style>
  a {
    color: inherit;
    text-decoration: none;
  }
  img {
    width: 110px;
    height: 100%;
  }
  @media (min-width: 768px) {
    img {
      width: 140px;
    }
  }
  @media (min-width: 1024px) {
    img {
      width: 160px;
      height: 100%;
    }
  }
</style>
